import { orchestrator } from 'satcheljs';
import onRemoveProjection from 'owa-popout-v2/lib/actions/onRemoveProjection';
import removeActiveDrawerPane from '../mutators/removeActiveDrawerPane';

orchestrator(onRemoveProjection, async actionMessage => {
    const { tabId } = actionMessage;

    // Clean up the active drawer pane for the tabId
    // This is needed to ensure that tabId is removed from the activePanes map
    removeActiveDrawerPane(tabId);
});
